import { DeviceStatusPipeModule } from './../pipes/device-status-pipe.module';
import { TableRowInnerComponent } from './components/table-row-inner/table-row-inner.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { DeviceTableComponent } from './device-table.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MatTableModule, MatPaginatorModule, MatButtonModule, MatMenuModule, MatSortModule } from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';

@NgModule({
  declarations: [DeviceTableComponent, TableRowInnerComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    CdkTableModule,
    DeviceStatusPipeModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatSortModule,
    TranslateModule
  ],
  exports: [
    DeviceTableComponent, TableRowInnerComponent
  ]
})
export class DeviceTableModule { }
